var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.31L21.9 13.41C22.68 12.63 22.68 11.36 21.9 10.58L20 8.69001V6.00001C20 4.90001 19.1 4.00001 18 4.00001H15.31L13.41 2.10001C12.63 1.32001 11.36 1.32001 10.58 2.10001L8.69001 4.00001H6.00001C4.90001 4.00001 4.00001 4.90001 4.00001 6.00001V8.69001L2.10001 10.59C1.32001 11.37 1.32001 12.64 2.10001 13.42L4.00001 15.32V18C4.00001 19.1 4.90001 20 6.00001 20H8.69001L10.59 21.9C11.37 22.68 12.64 22.68 13.42 21.9L15.32 20H18C19.1 20 20 19.1 20 18V15.31ZM12 18C8.69001 18 6.00001 15.31 6.00001 12C6.00001 8.69001 8.69001 6.00001 12 6.00001C15.31 6.00001 18 8.69001 18 12C18 15.31 15.31 18 12 18Z",
    fill: "#E8E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigIcon);
export default __webpack_public_path__ + "static/media/config-icon.cd3cf62f.svg";
export { ForwardRef as ReactComponent };